import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import * as purchaseOrderActions from '../purchase-orders/purchase-orders.actions';
import {
  catchError,
  map,
  mergeMap,
  switchMap,
  tap,
  throttleTime,
} from 'rxjs/operators';
import { from, Observable, of } from 'rxjs';
import {
  HideSpinner,
  ShowSpinner,
} from '../../../shared/spinner/spinner.action';
import { Action } from '@ngrx/store';
import * as ErrorActions from '../../error/error.actions';
import { ErrorType } from '../../error/model/error-type';
import { AlertMessageCommonService } from '../../../shared/alert-message-common/alert-message-common.service';
import { ServiceOrderService } from '../../backend/service-order/service-order.service';

type showSpinnerTypes = purchaseOrderActions.PurchaseOrderGetRequest;

const showSpinnerActions = [purchaseOrderActions.PURCHASE_ORDERS_GET_REQUEST];

type hideSpinnerTypes = purchaseOrderActions.PurchaseOrderGetReceive;

const hideSpinnerActions = [purchaseOrderActions.PURCHASE_ORDERS_GET_RECEIVE];

@Injectable()
export class PurchaseOrderEffects {
  constructor(
    private actions$: Actions,
    private serviceOrderService: ServiceOrderService,
    private alertMessageCommonService: AlertMessageCommonService
  ) {}

  @Effect()
  showSpinner: Observable<Action> = this.actions$.pipe(
    ofType<showSpinnerTypes>(...showSpinnerActions),
    map(() => new ShowSpinner())
  );

  @Effect()
  hideSpinner: Observable<Action> = this.actions$.pipe(
    ofType<hideSpinnerTypes>(...hideSpinnerActions),
    map(() => new HideSpinner())
  );

  @Effect()
  OnpurchaseOrderGetRequest$ = this.actions$.pipe(
    ofType<purchaseOrderActions.PurchaseOrderGetRequest>(
      purchaseOrderActions.PURCHASE_ORDERS_GET_REQUEST
    ),
    map((action) => action.payload),
    throttleTime(2000),
    switchMap((payload) =>
      from(this.serviceOrderService.workOrderGetPurchaseOrders(payload)).pipe(
        mergeMap((purchaseOrderList) => [
          new purchaseOrderActions.PurchaseOrderGetReceive({
            purchaseOrderList: purchaseOrderList,
            isScrolled: payload.isScrolled,
          }),
        ]),
        catchError((data) =>
          of(
            new ErrorActions.ErrorReceive({
              message: data.error.message,
              type: ErrorType.token,
              statusCode: data.status,
            })
          )
        )
      )
    )
  );
}
